import { render, staticRenderFns } from "./ImageStat.vue?vue&type=template&id=64e3b129&scoped=true"
import script from "./ImageStat.vue?vue&type=script&lang=js"
export * from "./ImageStat.vue?vue&type=script&lang=js"
import style0 from "./ImageStat.vue?vue&type=style&index=0&id=64e3b129&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e3b129",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64e3b129')) {
      api.createRecord('64e3b129', component.options)
    } else {
      api.reload('64e3b129', component.options)
    }
    module.hot.accept("./ImageStat.vue?vue&type=template&id=64e3b129&scoped=true", function () {
      api.rerender('64e3b129', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/ImageStat.vue"
export default component.exports